export default "__VITE_ASSET__A_gBbxa5__"